import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

// Utils
import { length } from '../../../../../../common/utils/immutableHelper';

// Selectors
import { useActiveTableSelector } from '../../../../../element/table/store/hotTableStoreHooks';
import {
    selectActiveTableCellSelection,
    selectActiveTableSharedFormattingValues,
} from '../../../../../element/table/store/selectors/activeHotTableSelectors';
import { userLanguagePreferenceSelector } from '../../../../../user/currentUserSelector';

// Components
import ToolbarPopupTool from '../../ToolbarPopupTool';
import CellTypePopupContainer from './CellTypeToolbarPopup';
import Icon from '../../../../../components/icons/Icon';
import createSwitchableTableComponent from './createSwitchableTableComponent';
import LegacyCellTypeTool from './legacy/LegacyCellTypeTool';

// Constants
import { PopupIds, PopupSections } from '../../../../../components/popupPanel/popupConstants';
import { CellTypeConstants } from '../../../../../../common/table/CellTypeConstants';
import { ImMNElement } from '../../../../../../common/elements/elementModelTypes';

type CellTypeToolIconProps = {
    activeCellType: keyof typeof CellTypeConstants;
};

const CellTypeToolIcon: React.FC<CellTypeToolIconProps> = (props) => {
    const { activeCellType } = props;

    const iconName = CellTypeConstants[activeCellType]?.icon || 'toolbar-cell-type';
    return <Icon name={iconName} />;
};

type CellTypeToolProps = {
    element: ImMNElement;
};

type CellTypeToolSwitchProps = CellTypeToolProps & Record<string, unknown>;

const CellTypeTool: React.FC<CellTypeToolProps> = (props) => {
    const locale = useSelector(userLanguagePreferenceSelector);
    const currentCellSelections = useActiveTableSelector(selectActiveTableCellSelection);

    // formatting options that are shared between all the selected cells
    // these will be the preselected options in the popup
    const sharedFormattingValues = useActiveTableSelector(selectActiveTableSharedFormattingValues);
    const activeCellType: keyof typeof CellTypeConstants | undefined = sharedFormattingValues?.name;

    // Keep track of the type that was clicked last so that we can show the formatting options
    const [lastClickedType, setLastClickedType] = useState(null);

    useEffect(() => {
        setLastClickedType(null);
    }, [currentCellSelections]);

    return (
        <ToolbarPopupTool
            {...props}
            // @ts-ignore - ToolbarPopupTool isn't TS so the type inference struggles
            locale={locale}
            name="Cell type"
            popupId={PopupIds.CELL_TYPE}
            closeSection={PopupSections.TOOLBAR}
            active={false}
            IconComponent={CellTypeToolIcon}
            toolName="CellType"
            disabled={length(currentCellSelections) === 0}
            buttonSelector=".CelltypeTool .Icon"
            PopupComponent={CellTypePopupContainer}
            activeCellType={activeCellType}
            sharedFormattingValues={sharedFormattingValues}
            lastClickedType={lastClickedType}
            setLastClickedType={setLastClickedType}
            preventFocus
        />
    );
};

export default createSwitchableTableComponent<CellTypeToolSwitchProps>(LegacyCellTypeTool, CellTypeTool);
